import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { LoadingBox } from "suregifts-component-lib";

import { BalanceCard } from "../../../components/organisms/merchant-wallets/BalanceCard";
import { CompanyCard } from "../../../components/organisms/merchant-wallets/CompanyCard";
import { TransactionHistoryView } from "../../../components/organisms/merchant-wallets/TransactionHistoryView";
import { WalletTransactionFilter } from "../../../components/organisms/merchant-wallets/data";
import { useGetMerchantWalletById, useGetMerchantWalletTransactions } from "../../../services/merchant-dashboard/wallet";

function MerchantWalletHistoryScreen() {
  const { merchantId } = useParams();
  const [filter, setFilter] = useState({ page: 1, search: "" } as WalletTransactionFilter);
  const { data: history, isLoading } = useGetMerchantWalletTransactions(filter);
  const { data: merchant } = useGetMerchantWalletById();

  const handleFilter = (params) => setFilter((prev) => ({ ...prev, ...params }));
  if (!merchant) return <></>;
  return (
    <div>
      <LoadingBox
        sx={(theme) => ({
          display: "grid",
          gap: "1.875rem",
          [theme.breakpoints.up("md")]: {
            gridTemplateColumns: "3fr 5fr",
          },
        })}
      >
        <CompanyCard store={merchant} />
        <BalanceCard store={merchant} />
      </LoadingBox>
      <TransactionHistoryView pageData={merchant} filter={filter} handleFilter={handleFilter} data={history} />
    </div>
  );
}

export default MerchantWalletHistoryScreen;
